export default "__VITE_ASSET__BPXZQCcj__"